import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogActions, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { ButtonDirective } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  standalone: true,
  imports: [
    FormsModule,
    ButtonDirective,
    MatDialogActions,
    MatDialogContent,
    MatDialogClose,
    DropdownModule,
  ],
  selector: 'pek-offer-file-translation',
  templateUrl: 'offer-file-translation.component.html',
  styleUrls: ['offer-file-translation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class OfferFileTranslationComponent {
  protected readonly languageCode: WritableSignal<string> = signal('en');

  protected readonly languages = [
    { label: 'Bulgarian', value: 'bg' },
    { label: 'German', value: 'de' },
    { label: 'English', value: 'en' },
    { label: 'Spanish', value: 'es' },
    { label: 'French', value: 'fr' },
    { label: 'Croatian', value: 'hr' },
    { label: 'Hungarian', value: 'hu' },
    { label: 'Italian', value: 'it' },
    { label: 'Lithuanian', value: 'lt' },
    { label: 'Latvian', value: 'lv' },
    { label: 'Norwegian', value: 'no' },
    { label: 'Dutch', value: 'nl' },
    { label: 'Romanian', value: 'ro' },
    { label: 'Russian', value: 'ru' },
    { label: 'Slovenian', value: 'sl' },
    { label: 'Serbian (Latin)', value: 'sr' },
    { label: 'Serbian (Cyrillic)', value: 'sr-cyrl' },
    { label: 'Swedish', value: 'sv' },
    { label: 'Turkish', value: 'tr' },
    { label: 'Ukrainian', value: 'uk' },
  ];
}
